// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true,valid_types=protovalidate_required"
// @generated from file proto/v1/admin.proto (package vmspdb.api.proto.v1, syntax proto3)
/* eslint-disable */

// buf:lint:ignore PACKAGE_DIRECTORY_MATCH

import type { Message } from '@bufbuild/protobuf';
import type {
  GenEnum,
  GenFile,
  GenMessage,
  GenService,
} from '@bufbuild/protobuf/codegenv2';
import {
  enumDesc,
  fileDesc,
  messageDesc,
  serviceDesc,
} from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file proto/v1/admin.proto.
 */
export const file_proto_v1_admin: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChRwcm90by92MS9hZG1pbi5wcm90bxITdm1zcGRiLmFwaS5wcm90by52MSJ6Ch1BZG1pblNlcnZpY2VTZWFyY2hTeW5jUmVxdWVzdBI9Cgpjb2xsZWN0aW9uGAEgASgOMikudm1zcGRiLmFwaS5wcm90by52MS5TZWFyY2hTeW5jQ29sbGVjdGlvbhINCgVyZXNldBgCIAEoCBILCgNhbGwYAyABKAgiewoeQWRtaW5TZXJ2aWNlU2VhcmNoU3luY1Jlc3BvbnNlEg4KBnF1ZXVlZBgBIAEoCBI1CgZzdGF0dXMYAiABKA4yJS52bXNwZGIuYXBpLnByb3RvLnYxLlNlYXJjaFN5bmNTdGF0dXMSEgoKbWVzc2FnZV9pZBgDIAEoCSIsChtBZG1pblNlcnZpY2VGaWxlU3luY1JlcXVlc3QSDQoFZm9yY2UYASABKAgiHgocQWRtaW5TZXJ2aWNlRmlsZVN5bmNSZXNwb25zZSr2AQoUU2VhcmNoU3luY0NvbGxlY3Rpb24SJgoiU0VBUkNIX1NZTkNfQ09MTEVDVElPTl9VTlNQRUNJRklFRBAAEiMKH1NFQVJDSF9TWU5DX0NPTExFQ1RJT05fUFJPSkVDVFMQARIfChtTRUFSQ0hfU1lOQ19DT0xMRUNUSU9OX0pPQlMQAhIiCh5TRUFSQ0hfU1lOQ19DT0xMRUNUSU9OX1NVUlZFWVMQAxIiCh5TRUFSQ0hfU1lOQ19DT0xMRUNUSU9OX1BFUk1JVFMQBBIoCiRTRUFSQ0hfU1lOQ19DT0xMRUNUSU9OX1RJTUVfVFJBQ0tJTkcQBSqWAQoQU2VhcmNoU3luY1N0YXR1cxIiCh5TRUFSQ0hfU1lOQ19TVEFUVVNfVU5TUEVDSUZJRUQQABIeChpTRUFSQ0hfU1lOQ19TVEFUVVNfU1RBUlRFRBABEh4KGlNFQVJDSF9TWU5DX1NUQVRVU19XQUlUSU5HEAISHgoaU0VBUkNIX1NZTkNfU1RBVFVTX1JFRlVTRUQQAzL6AQoMQWRtaW5TZXJ2aWNlEnEKCEZpbGVTeW5jEjAudm1zcGRiLmFwaS5wcm90by52MS5BZG1pblNlcnZpY2VGaWxlU3luY1JlcXVlc3QaMS52bXNwZGIuYXBpLnByb3RvLnYxLkFkbWluU2VydmljZUZpbGVTeW5jUmVzcG9uc2UiABJ3CgpTZWFyY2hTeW5jEjIudm1zcGRiLmFwaS5wcm90by52MS5BZG1pblNlcnZpY2VTZWFyY2hTeW5jUmVxdWVzdBozLnZtc3BkYi5hcGkucHJvdG8udjEuQWRtaW5TZXJ2aWNlU2VhcmNoU3luY1Jlc3BvbnNlIgBCKlooZ28udm1zcGRiLmFwcC9wbGF0Zm9ybS9pbnRlcm5hbC9wcm90by92MWIGcHJvdG8z',
  );

/**
 * @generated from message vmspdb.api.proto.v1.AdminServiceSearchSyncRequest
 */
export type AdminServiceSearchSyncRequest =
  Message<'vmspdb.api.proto.v1.AdminServiceSearchSyncRequest'> & {
    /**
     * @generated from field: vmspdb.api.proto.v1.SearchSyncCollection collection = 1;
     */
    collection: SearchSyncCollection;

    /**
     * @generated from field: bool reset = 2;
     */
    reset: boolean;

    /**
     * @generated from field: bool all = 3;
     */
    all: boolean;
  };

/**
 * @generated from message vmspdb.api.proto.v1.AdminServiceSearchSyncRequest
 */
export type AdminServiceSearchSyncRequestJson = {
  /**
   * @generated from field: vmspdb.api.proto.v1.SearchSyncCollection collection = 1;
   */
  collection?: SearchSyncCollectionJson;

  /**
   * @generated from field: bool reset = 2;
   */
  reset?: boolean;

  /**
   * @generated from field: bool all = 3;
   */
  all?: boolean;
};

export type AdminServiceSearchSyncRequestValid = AdminServiceSearchSyncRequest;

/**
 * Describes the message vmspdb.api.proto.v1.AdminServiceSearchSyncRequest.
 * Use `create(AdminServiceSearchSyncRequestSchema)` to create a new message.
 */
export const AdminServiceSearchSyncRequestSchema: GenMessage<
  AdminServiceSearchSyncRequest,
  {
    jsonType: AdminServiceSearchSyncRequestJson;
    validType: AdminServiceSearchSyncRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_admin, 0);

/**
 * @generated from message vmspdb.api.proto.v1.AdminServiceSearchSyncResponse
 */
export type AdminServiceSearchSyncResponse =
  Message<'vmspdb.api.proto.v1.AdminServiceSearchSyncResponse'> & {
    /**
     * Unchanged in number and meaning: the request was accepted and the work is
     * on a queue. Existing clients and the regression-lock tests in
     * apps/api-e2e/tests/admin/search-sync.test.ts read only this field.
     *
     * @generated from field: bool queued = 1;
     */
    queued: boolean;

    /**
     * Which of started / waiting / refused actually happened. Additive, so a
     * client that does not read it sees exactly today's behaviour.
     *
     * @generated from field: vmspdb.api.proto.v1.SearchSyncStatus status = 2;
     */
    status: SearchSyncStatus;

    /**
     * The Pub/Sub message ID the publisher already logs on dispatch and the
     * worker logs on receipt — the existing correlation key between a request
     * and the run it triggered, rather than a second identifier to map. The
     * local in-process binding has no server-assigned ID and reports its
     * synthesised stand-in here.
     *
     * @generated from field: string message_id = 3;
     */
    messageId: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.AdminServiceSearchSyncResponse
 */
export type AdminServiceSearchSyncResponseJson = {
  /**
   * Unchanged in number and meaning: the request was accepted and the work is
   * on a queue. Existing clients and the regression-lock tests in
   * apps/api-e2e/tests/admin/search-sync.test.ts read only this field.
   *
   * @generated from field: bool queued = 1;
   */
  queued?: boolean;

  /**
   * Which of started / waiting / refused actually happened. Additive, so a
   * client that does not read it sees exactly today's behaviour.
   *
   * @generated from field: vmspdb.api.proto.v1.SearchSyncStatus status = 2;
   */
  status?: SearchSyncStatusJson;

  /**
   * The Pub/Sub message ID the publisher already logs on dispatch and the
   * worker logs on receipt — the existing correlation key between a request
   * and the run it triggered, rather than a second identifier to map. The
   * local in-process binding has no server-assigned ID and reports its
   * synthesised stand-in here.
   *
   * @generated from field: string message_id = 3;
   */
  messageId?: string;
};

export type AdminServiceSearchSyncResponseValid =
  AdminServiceSearchSyncResponse;

/**
 * Describes the message vmspdb.api.proto.v1.AdminServiceSearchSyncResponse.
 * Use `create(AdminServiceSearchSyncResponseSchema)` to create a new message.
 */
export const AdminServiceSearchSyncResponseSchema: GenMessage<
  AdminServiceSearchSyncResponse,
  {
    jsonType: AdminServiceSearchSyncResponseJson;
    validType: AdminServiceSearchSyncResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_admin, 1);

/**
 * @generated from message vmspdb.api.proto.v1.AdminServiceFileSyncRequest
 */
export type AdminServiceFileSyncRequest =
  Message<'vmspdb.api.proto.v1.AdminServiceFileSyncRequest'> & {
    /**
     * @generated from field: bool force = 1;
     */
    force: boolean;
  };

/**
 * @generated from message vmspdb.api.proto.v1.AdminServiceFileSyncRequest
 */
export type AdminServiceFileSyncRequestJson = {
  /**
   * @generated from field: bool force = 1;
   */
  force?: boolean;
};

export type AdminServiceFileSyncRequestValid = AdminServiceFileSyncRequest;

/**
 * Describes the message vmspdb.api.proto.v1.AdminServiceFileSyncRequest.
 * Use `create(AdminServiceFileSyncRequestSchema)` to create a new message.
 */
export const AdminServiceFileSyncRequestSchema: GenMessage<
  AdminServiceFileSyncRequest,
  {
    jsonType: AdminServiceFileSyncRequestJson;
    validType: AdminServiceFileSyncRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_admin, 2);

/**
 * @generated from message vmspdb.api.proto.v1.AdminServiceFileSyncResponse
 */
export type AdminServiceFileSyncResponse =
  Message<'vmspdb.api.proto.v1.AdminServiceFileSyncResponse'> & {};

/**
 * @generated from message vmspdb.api.proto.v1.AdminServiceFileSyncResponse
 */
export type AdminServiceFileSyncResponseJson = {};

export type AdminServiceFileSyncResponseValid = AdminServiceFileSyncResponse;

/**
 * Describes the message vmspdb.api.proto.v1.AdminServiceFileSyncResponse.
 * Use `create(AdminServiceFileSyncResponseSchema)` to create a new message.
 */
export const AdminServiceFileSyncResponseSchema: GenMessage<
  AdminServiceFileSyncResponse,
  {
    jsonType: AdminServiceFileSyncResponseJson;
    validType: AdminServiceFileSyncResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_admin, 3);

/**
 * @generated from enum vmspdb.api.proto.v1.SearchSyncCollection
 */
export enum SearchSyncCollection {
  /**
   * @generated from enum value: SEARCH_SYNC_COLLECTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SEARCH_SYNC_COLLECTION_PROJECTS = 1;
   */
  PROJECTS = 1,

  /**
   * @generated from enum value: SEARCH_SYNC_COLLECTION_JOBS = 2;
   */
  JOBS = 2,

  /**
   * @generated from enum value: SEARCH_SYNC_COLLECTION_SURVEYS = 3;
   */
  SURVEYS = 3,

  /**
   * @generated from enum value: SEARCH_SYNC_COLLECTION_PERMITS = 4;
   */
  PERMITS = 4,

  /**
   * @generated from enum value: SEARCH_SYNC_COLLECTION_TIME_TRACKING = 5;
   */
  TIME_TRACKING = 5,
}

/**
 * @generated from enum vmspdb.api.proto.v1.SearchSyncCollection
 */
export type SearchSyncCollectionJson =
  | 'SEARCH_SYNC_COLLECTION_UNSPECIFIED'
  | 'SEARCH_SYNC_COLLECTION_PROJECTS'
  | 'SEARCH_SYNC_COLLECTION_JOBS'
  | 'SEARCH_SYNC_COLLECTION_SURVEYS'
  | 'SEARCH_SYNC_COLLECTION_PERMITS'
  | 'SEARCH_SYNC_COLLECTION_TIME_TRACKING';

/**
 * Describes the enum vmspdb.api.proto.v1.SearchSyncCollection.
 */
export const SearchSyncCollectionSchema: GenEnum<
  SearchSyncCollection,
  SearchSyncCollectionJson
> = /*@__PURE__*/ enumDesc(file_proto_v1_admin, 0);

/**
 * SearchSyncStatus reports what happened to a re-index request: the work
 * started, it is waiting behind a run already in progress, or it was refused.
 * The three are mutually exclusive, which is why this is an enum rather than
 * parallel booleans.
 *
 * @generated from enum vmspdb.api.proto.v1.SearchSyncStatus
 */
export enum SearchSyncStatus {
  /**
   * @generated from enum value: SEARCH_SYNC_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SEARCH_SYNC_STATUS_STARTED = 1;
   */
  STARTED = 1,

  /**
   * @generated from enum value: SEARCH_SYNC_STATUS_WAITING = 2;
   */
  WAITING = 2,

  /**
   * @generated from enum value: SEARCH_SYNC_STATUS_REFUSED = 3;
   */
  REFUSED = 3,
}

/**
 * SearchSyncStatus reports what happened to a re-index request: the work
 * started, it is waiting behind a run already in progress, or it was refused.
 * The three are mutually exclusive, which is why this is an enum rather than
 * parallel booleans.
 *
 * @generated from enum vmspdb.api.proto.v1.SearchSyncStatus
 */
export type SearchSyncStatusJson =
  | 'SEARCH_SYNC_STATUS_UNSPECIFIED'
  | 'SEARCH_SYNC_STATUS_STARTED'
  | 'SEARCH_SYNC_STATUS_WAITING'
  | 'SEARCH_SYNC_STATUS_REFUSED';

/**
 * Describes the enum vmspdb.api.proto.v1.SearchSyncStatus.
 */
export const SearchSyncStatusSchema: GenEnum<
  SearchSyncStatus,
  SearchSyncStatusJson
> = /*@__PURE__*/ enumDesc(file_proto_v1_admin, 1);

/**
 * @generated from service vmspdb.api.proto.v1.AdminService
 */
export const AdminService: GenService<{
  /**
   * @generated from rpc vmspdb.api.proto.v1.AdminService.FileSync
   */
  fileSync: {
    methodKind: 'unary';
    input: typeof AdminServiceFileSyncRequestSchema;
    output: typeof AdminServiceFileSyncResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.AdminService.SearchSync
   */
  searchSync: {
    methodKind: 'unary';
    input: typeof AdminServiceSearchSyncRequestSchema;
    output: typeof AdminServiceSearchSyncResponseSchema;
  };
}> = /*@__PURE__*/ serviceDesc(file_proto_v1_admin, 0);
